<template>
  <div>
    <b-container>

      <b-modal v-model="dateModal"
               header-bg-variant="primary"
               header-text-variant="light"
               class="mt-3"
               :modal-footer="false"
               @ok="handleDateValidation"
               ok-title="Κατέβασμα"
               cancel-title="Άκυρο"
               :no-close-on-esc="true"
               :no-close-on-backdrop="true"
               :hide-header-close="true"
               title="Παρακαλώ επιλέξτε ημερομηνίες">
        <b-col sm="12">
          <form @submit.stop.prevent="handleDownloadRequest">
            <small>Από:</small>
            <datepicker :bootstrapStyling="true" :state="dateFromInputState" v-model="selectedDateFrom"></datepicker>
            <!--<b-form-input :state="dateFromInputState" type="date" v-model="selectedDateFrom"></b-form-input>-->
            <small><p v-if="showSubMsgFrom">Επιλέξτε σωστή ημερομηνία για να συνεχίσετε...</p></small>
            <br />
            <small>Έως:</small>
            <datepicker :bootstrapStyling="true" :state="dateToInputState" v-model="selectedDateTo"></datepicker>
            <!--<b-form-input :state="dateToInputState" type="date" v-model="selectedDateTo"></b-form-input>-->
            <small><p v-if="showSubMsgTo">Επιλέξτε σωστή ημερομηνία για να συνεχίσετε...</p></small>
            <p v-show="correctDate">Η αρχική ημερομηνία πρέπει να είναι προγενέστερη της τελικής!</p>
          </form>
        </b-col>
      </b-modal>

      <div>
        <b-card-group deck>

          <b-card border-variant="primary"
                  header-tag="header"
                  footer-tag="footer">
            <h6 slot="header"
                class="mb-0">Όλα τα διανεμηθέντα βιβλία του τρέχοντος Ακαδημαϊκού έτους</h6>
            <p class="card-text">Επιλέξτε τύπο αρχείου</p>
            <b-button v-b-tooltip.hover="'Τύπος Αρχείου PDF'"
                      variant="outline-info" @click="downloadPDF(true, 'allBooksReport')">Αναφορά PDF
            </b-button>
            <b-button v-b-tooltip.hover="'Τύπος Αρχείου Excel'"
                      variant="outline-info" @click="downloadExcel(true, 'allBooksReport')">Αναφορά XLS
            </b-button>
          </b-card>

          <b-card v-show="distPointType" border-variant="primary"
                  header-tag="header"
                  footer-tag="footer">
            <h6 slot="header"
                class="mb-0">Εκδότες και αντιστοιχισμένα βιβλία του τρέχοντος Ακαδημαϊκού έτους</h6>
            <p class="card-text">Επιλέξτε τύπο αρχείου</p>
            <b-button v-b-tooltip.hover="'Τύπος Αρχείου PDF'"
                      variant="outline-info" @click="downloadPDF(true, 'activeBooksReport')">Αναφορά PDF
            </b-button>
            <b-button v-b-tooltip.hover="'Τύπος Αρχείου Excel'"
                      variant="outline-info" @click="downloadExcel(true, 'activeBooksReport')">Αναφορά XLS
            </b-button>
          </b-card>

          <b-card border-variant="primary"
                  header-tag="header"
                  footer-tag="footer">
            <h6 slot="header"
                class="mb-0">Αναφορά διανομών σε επιλεγμένο χρονικό διάστημα</h6>
            <p class="card-text">Επιλέξτε τύπο αρχείου</p>

            <b-button v-b-tooltip.hover="'Τύπος Αρχείου PDF'"
                      variant="outline-info" @click="downloadPDF(false, 'allDeliveriesReport')">Αναφορά PDF
            </b-button>
            <b-button v-b-tooltip.hover="'Τύπος Αρχείου Excel'"
                      variant="outline-info" @click="downloadExcel(false, 'allDeliveriesReport')">Αναφορά XLS
            </b-button>
          </b-card>

        </b-card-group>
      </div>

    </b-container>
  </div>
</template>

<script>

  import {GlobalEudoxusBus} from "../../js/DistributionRequestService";
  import requests from '../../js/DistributionRequestService';
  import AppUtilities from '../../js/AppUtilities';
  import Datepicker from 'vuejs-datepicker';

  export default {
    data() {
      return {
        dateModal: false,
        selectedDateFrom: '',
        selectedDateTo: '',
        dateFromInputState: null,
        dateToInputState: null,
        fromDate: '',
        toDate: '',
        showSubMsgFrom: false,
        showSubMsgTo: false,
        format: '',
        correctDate: false,
        distPointType: null
      }
    },
    components: {
      'datepicker': Datepicker
    },
    methods: {
      downloadPDF(currentYear, token) {
        this.modalReset();
        this.format = 'pdf';
        !currentYear ? this.showModal() : this.handleDownloadRequest("", "", token, this.format);
      },
      downloadExcel(currentYear, token) {
        this.modalReset();
        this.format = 'xls';
        !currentYear ? this.showModal() : this.handleDownloadRequest("", "", token, this.format);
      },
      handleDateValidation(evt) {
        evt.preventDefault();

        if(this.selectedDateFrom === '') {
          this.dateFromInputState = false;
          this.showSubMsgFrom = true;
          return;
        }

        if(this.selectedDateTo === '') {
          this.dateToInputState = false;
          this.showSubMsgTo = true;
          return;
        }

        let dateFrom = AppUtilities.parseCorrectDate(this.selectedDateFrom);
        let dateTo = AppUtilities.parseCorrectDate(this.selectedDateTo);

        if(new Date(dateFrom) > new Date(dateTo)) {
          this.dateFromInputState = false;
          this.dateToInputState = false;
          this.correctDate = true;
          return;
        }

        this.handleDownloadRequest(dateFrom, dateTo, 'allDeliveriesReport', this.format);
      },
      handleDownloadRequest(from, to, token, format) {
        this.dateModal = false;
        // this.$refs.dateModal.hide();
        requests.getSubmitFileDownload(token, format, from, to, '');
        this.modalReset();
        this.format = '';
      },
      showModal() {
        this.modalReset();
        this.dateModal = true;
        // this.$refs.dateModal.show();
      },
      modalReset() {
        this.showSubMsgFrom = false;
        this.dateFromInputState = null;
        this.selectedDateFrom = '';

        this.showSubMsgTo = false;
        this.dateToInputState = null;
        this.selectedDateTo = '';
        this.correctDate = false;
      }
    },
    created() {
      GlobalEudoxusBus.$on('reportsTabsLayoutSetup', flag => {
        this.distPointType = flag;
      });
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ReportsTabComponents/ReportsTabComponent.vue